module.exports = __webpack_public_path__ + "img/model.a1439242.svg";